import moment from 'moment-timezone'

export default {
  methods: {
    /**
     * Helper for converting date.
     *
     * @param value
     * @param timeZone
     * @param dateFormat
     * @returns {string|null|*}
     */
    formatDate(value, timeZone = moment.tz.guess(), dateFormat = 'LL') {
      if (value) {
        // Set user locale from browser
        moment.locale(navigator.language || navigator.userLanguage)
        let timeStamp = Date.parse(value.replace(/ /g, 'T'))
        let date = moment(timeStamp).tz(timeZone)
        if (date.isValid()) {
          if (moment.duration(moment().tz(timeZone).diff(date)).asHours() <= 24) {
            return date.fromNow()
          }
          return date.format(dateFormat)
        }
        return 'Date is not valid'
      }
      return null
    },
  },
}
